import { render, staticRenderFns } from "./CustomHorizontal.vue?vue&type=template&id=507248fa&"
import script from "./CustomHorizontal.vue?vue&type=script&lang=js&"
export * from "./CustomHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports